import ApplicationOwner from "components/Application/ApplicationOwner"
import { useEffect, useState } from "react"
import { Row } from "reactstrap"

import Application from "services/applications/Application.service"

const loggedInUser = JSON.parse(localStorage.getItem("authUser"))
const appService = new Application(loggedInUser)

const DisposalDetails = props => {
  useEffect(() => {}, [])
  return (
    <>
      {props.appDetails.guidance_disposal.company ? (
        <ApplicationOwner
          appDetails={props.appDetails}
          isCompany={props.appDetails.guidance_disposal.company_id}
          company={props.appDetails.guidance_disposal.company}
        />
      ) : (
        <ApplicationOwner appDetails={props.appDetails} />
      )}
      <Row>
        <h5>Application Details</h5>
        <table className="table table-striped table-responsive">
          <thead>
            <tr>
              <th>Item</th>
              <th>Value</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td> Disposal Types </td>
              <td>
                {props.appDetails.guidance_disposal.disposal_product_types.name}
              </td>
            </tr>

            <tr>
              <td>origin</td>
              <td>{props.appDetails.guidance_disposal.origin_of_products}</td>
            </tr>

            <tr>
              <td>Quantity</td>
              <td>{props.appDetails.guidance_disposal.quantity}</td>
            </tr>
            <tr>
              <td>Quantity Measure</td>
              <td>{props.appDetails.guidance_disposal.quantity_measure.name}</td>
            </tr>
            <tr>
              <td>Chemical Composition</td>
              <td>{props.appDetails.guidance_disposal.chemical_composition}</td>
            </tr>
            <tr>
              <td>Disposal Product Types</td>
              <td>
                {props.appDetails.guidance_disposal.disposal_product_types.name}
              </td>
            </tr>
            <tr>
              <td>Disposal Reasons</td>
              <td>
                {props.appDetails.guidance_disposal.disposal_reasons.name}
              </td>
            </tr>
            <tr>
              <td>Description</td>
              <td>{props.appDetails.guidance_disposal.description}</td>
            </tr>
            <tr>
              <td>Location</td>
              <td>{props.appDetails.guidance_disposal.location}</td>
            </tr>
          </tbody>
        </table>
      </Row>
    </>
  )
}

export default DisposalDetails
